// 初始 mock 資料：一趟已經有內容的示範 Trip，方便一打開 demo 就能看到各功能的樣子。
// 之後使用者自己建立的 Trip 不會套用這份資料，只會是空的骨架（見 store/modules 各自的 create action）。
import dayjs from 'dayjs'
import { toMinor } from '@/utils/format'

const today = dayjs()
const start = today.subtract(2, 'day')
const end = today.add(4, 'day')

export const DEMO_TRIP_ID = 'trip-demo-tokyo'

const MEMBER_AMY = 'member-amy'
const MEMBER_JASON = 'member-jason'
const MEMBER_KEN = 'member-ken'
const MEMBER_TOM = 'member-tom'
export const CURRENT_USER_ID = MEMBER_AMY

export const seedMembers = [
  { id: MEMBER_AMY, tripId: DEMO_TRIP_ID, name: 'Amy', color: '#ff8f6b', role: 'owner', isPlaceholder: false, status: 'active' },
  { id: MEMBER_JASON, tripId: DEMO_TRIP_ID, name: 'Jason', color: '#5b8def', role: 'member', isPlaceholder: false, status: 'active' },
  { id: MEMBER_KEN, tripId: DEMO_TRIP_ID, name: 'Ken', color: '#3dbd8c', role: 'member', isPlaceholder: false, status: 'active' },
  { id: MEMBER_TOM, tripId: DEMO_TRIP_ID, name: 'Tom', color: '#b17ee0', role: 'member', isPlaceholder: true, status: 'active' }
]

export const seedTrips = [
  {
    id: DEMO_TRIP_ID,
    name: '2026 Tokyo Summer Trip',
    description: '四人東京自由行，主題是咖啡、古著與美術館。',
    destinations: ['東京', '鎌倉'],
    startDate: start.format('YYYY-MM-DD'),
    endDate: end.format('YYYY-MM-DD'),
    coverEmoji: '🗼',
    settlementCurrency: 'HKD',
    timezone: 'Asia/Tokyo',
    tags: ['#food', '#film', '#architecture', '#coffee'],
    ownerId: MEMBER_AMY,
    memberIds: [MEMBER_AMY, MEMBER_JASON, MEMBER_KEN, MEMBER_TOM],
    inviteRequiresApproval: false,
    allowMemberInvite: true,
    manualStartedAt: null,
    manualEndedAt: null,
    createdAt: start.subtract(20, 'day').toISOString()
  }
]

export const seedPoints = [
  {
    id: 'point-glitch-coffee', tripId: DEMO_TRIP_ID, placeId: 'mock-glitch-coffee', name: 'Glitch Coffee',
    lat: 35.6944, lng: 139.7580, address: '東京都千代田区神田錦町3-16', category: 'coffee',
    origin: 'planned', status: 'visited', planPriority: 'confirmed', plannedDate: start.format('YYYY-MM-DD'),
    wantRevisit: false, visitedBy: [MEMBER_AMY, MEMBER_JASON], visitedAt: start.hour(8).minute(21).toISOString(),
    note: '酸度很高，適合早上提神。', links: [], savedBy: [MEMBER_AMY], visibility: 'trip'
  },
  {
    id: 'point-teamlab', tripId: DEMO_TRIP_ID, placeId: 'mock-teamlab', name: 'teamLab Planets',
    lat: 35.6465, lng: 139.7930, address: '東京都江東区豊洲6-1-16', category: 'attraction',
    origin: 'planned', status: 'planned', planPriority: 'confirmed', plannedDate: today.add(1, 'day').format('YYYY-MM-DD'),
    wantRevisit: false, visitedBy: [], visitedAt: null,
    note: '', links: [], savedBy: [MEMBER_AMY, MEMBER_KEN], visibility: 'trip'
  },
  {
    id: 'point-tsukiji', tripId: DEMO_TRIP_ID, placeId: 'mock-tsukiji', name: '築地場外市場',
    lat: 35.6654, lng: 139.7707, address: '東京都中央区築地4丁目', category: 'food',
    origin: 'planned', status: 'missed', planPriority: 'considering', plannedDate: null,
    wantRevisit: true, visitedBy: [], visitedAt: null,
    note: '這次時間不夠，下次一定要早起去。', links: [], savedBy: [MEMBER_JASON], visibility: 'trip'
  },
  {
    id: 'point-shibuya-sky', tripId: DEMO_TRIP_ID, placeId: 'mock-shibuya-sky', name: 'Shibuya Sky',
    lat: 35.6585, lng: 139.7016, address: '東京都渋谷区渋谷2-24-12', category: 'attraction',
    origin: 'planned', status: 'visited', planPriority: 'confirmed', plannedDate: start.format('YYYY-MM-DD'),
    wantRevisit: true, visitedBy: [MEMBER_AMY, MEMBER_JASON, MEMBER_KEN, MEMBER_TOM], visitedAt: start.hour(18).minute(3).toISOString(),
    note: '整趟旅行最喜歡的地方！', links: [], savedBy: [MEMBER_AMY], visibility: 'public'
  },
  {
    id: 'point-shimokitazawa', tripId: DEMO_TRIP_ID, placeId: 'mock-shimokitazawa', name: '下北澤古著店',
    lat: 35.6615, lng: 139.6682, address: '東京都世田谷区北沢2丁目', category: 'shopping',
    origin: 'discovered', status: 'visited', planPriority: 'confirmed', plannedDate: null,
    wantRevisit: true, visitedBy: [MEMBER_AMY], visitedAt: start.hour(14).minute(32).toISOString(),
    note: '本身完全沒有計畫，經過看到就進去了。', links: [], savedBy: [MEMBER_AMY], visibility: 'trip'
  },
  {
    id: 'point-daikanyama', tripId: DEMO_TRIP_ID, placeId: 'mock-daikanyama-tsite', name: '代官山蔦屋書店',
    lat: 35.6484, lng: 139.6980, address: '東京都渋谷区猿楽町17-5', category: 'shopping',
    origin: 'planned', status: 'planned', planPriority: 'considering', plannedDate: null,
    wantRevisit: false, visitedBy: [], visitedAt: null,
    note: '', links: [], savedBy: [MEMBER_KEN], visibility: 'trip'
  },
  {
    id: 'point-park-hyatt', tripId: DEMO_TRIP_ID, placeId: 'mock-park-hyatt', name: 'Park Hyatt Tokyo',
    lat: 35.6859, lng: 139.6907, address: '東京都新宿区西新宿3-7-1-2', category: 'lodging',
    origin: 'planned', status: 'planned', planPriority: 'considering', plannedDate: null,
    wantRevisit: false, visitedBy: [], visitedAt: null,
    note: '', links: [], savedBy: [MEMBER_AMY], visibility: 'trip',
    lodging: { checkIn: start.format('YYYY-MM-DD'), checkOut: end.format('YYYY-MM-DD'), price: 17000, currency: 'JPY', roomType: 'Park Room', link: '', pros: '近車站、樓層景觀好', cons: '房間偏小', bookingStatus: '未訂' }
  }
]

export const seedDecisions = [
  {
    id: 'decision-day3', tripId: DEMO_TRIP_ID, question: '第三天去哪裡？', multi: false,
    options: [
      { id: 'opt-kamakura', label: '鎌倉', pointId: null },
      { id: 'opt-hakone', label: '箱根', pointId: null },
      { id: 'opt-shopping', label: '市區購物', pointId: null }
    ],
    deadline: today.add(1, 'day').toISOString(),
    hideResultsUntilVoted: false,
    status: 'open',
    resultOptionId: null,
    createdBy: MEMBER_KEN,
    votes: [
      { memberId: MEMBER_KEN, optionIds: ['opt-kamakura'], reason: '想看看電車平交道' },
      { memberId: MEMBER_TOM, optionIds: ['opt-kamakura'], reason: '' }
    ]
  },
  {
    id: 'decision-hotel', tripId: DEMO_TRIP_ID, question: '要住 Park Hyatt 嗎？', multi: false,
    options: [
      { id: 'opt-yes', label: '住這間', pointId: 'point-park-hyatt' },
      { id: 'opt-no', label: '再找別的', pointId: null }
    ],
    deadline: null,
    hideResultsUntilVoted: false,
    status: 'decided',
    resultOptionId: 'opt-yes',
    createdBy: MEMBER_AMY,
    votes: [
      { memberId: MEMBER_AMY, optionIds: ['opt-yes'], reason: '' },
      { memberId: MEMBER_JASON, optionIds: ['opt-yes'], reason: '貴一晚沒關係' },
      { memberId: MEMBER_KEN, optionIds: ['opt-yes'], reason: '' }
    ]
  }
]

export const seedInfoItems = [
  {
    id: 'info-coffee-video', tripId: DEMO_TRIP_ID, url: 'https://www.youtube.com/watch?v=tokyo-coffee-guide',
    kind: 'youtube', title: 'Tokyo Coffee Guide — 18 mins', thumbnail: '☕', note: '介紹的幾間都想去',
    pointIds: ['point-glitch-coffee'], tags: ['#coffee'], createdBy: MEMBER_AMY, visibility: 'trip'
  },
  {
    id: 'info-shopping-blog', tripId: DEMO_TRIP_ID, url: 'https://example.com/tokyo-vintage-shopping',
    kind: 'web', title: '東京古著店地圖整理', thumbnail: '🧥', note: '',
    pointIds: ['point-shimokitazawa', 'point-daikanyama'], tags: ['#shopping', '#vintage'], createdBy: MEMBER_KEN, visibility: 'trip'
  }
]

export const seedTodos = [
  { id: 'todo-book-hotel', tripId: DEMO_TRIP_ID, title: 'Book Hotel', assigneeId: MEMBER_AMY, due: start.subtract(10, 'day').format('YYYY-MM-DD'), pointId: 'point-park-hyatt', note: '', visibility: 'trip', done: true, doneAt: start.subtract(9, 'day').toISOString() },
  { id: 'todo-jr-pass', tripId: DEMO_TRIP_ID, title: 'Buy JR Pass', assigneeId: MEMBER_JASON, due: start.subtract(3, 'day').format('YYYY-MM-DD'), pointId: null, note: '', visibility: 'trip', done: false, doneAt: null },
  { id: 'todo-restaurant', tripId: DEMO_TRIP_ID, title: 'Reserve teamLab 門票', assigneeId: MEMBER_KEN, due: today.add(1, 'day').format('YYYY-MM-DD'), pointId: 'point-teamlab', note: '記得選晚場', visibility: 'trip', done: false, doneAt: null },
  { id: 'todo-sim', tripId: DEMO_TRIP_ID, title: 'Check SIM Card', assigneeId: MEMBER_TOM, due: start.format('YYYY-MM-DD'), pointId: null, note: '', visibility: 'trip', done: true, doneAt: start.toISOString() },
  { id: 'todo-packing', tripId: DEMO_TRIP_ID, title: '我的行李清單', assigneeId: MEMBER_AMY, due: null, pointId: null, note: '私人待辦', visibility: 'private', done: false, doneAt: null }
]

export const seedBudgets = [
  { tripId: DEMO_TRIP_ID, category: '機票', amount: 3000 },
  { tripId: DEMO_TRIP_ID, category: '住宿', amount: 2500 },
  { tripId: DEMO_TRIP_ID, category: '餐飲', amount: 2000 },
  { tripId: DEMO_TRIP_ID, category: '購物', amount: 2000 },
  { tripId: DEMO_TRIP_ID, category: '交通', amount: 1000 },
  { tripId: DEMO_TRIP_ID, category: '門票', amount: 800 },
  { tripId: DEMO_TRIP_ID, category: '其他', amount: 500 }
]

export const seedExchangeRates = [
  { tripId: DEMO_TRIP_ID, currency: 'JPY', rate: 0.052 },
  { tripId: DEMO_TRIP_ID, currency: 'HKD', rate: 1 }
]

function makeExpense (id, title, amount, currency, rate, payerId, category, occurredAt, shareIds, note) {
  const amountMinor = toMinor(amount)
  const settlementMinor = Math.round(amountMinor * rate)
  const even = Math.floor(settlementMinor / shareIds.length)
  const remainder = settlementMinor - even * shareIds.length
  const shares = shareIds.map((memberId, idx) => ({
    memberId,
    amountMinor: even + (idx === 0 ? remainder : 0)
  }))
  return {
    id, tripId: DEMO_TRIP_ID, title, amountMinor, currency, rateSnapshot: rate,
    payerId, category, occurredAt, splitMode: 'even', shares,
    visibility: 'trip', receiptImage: null, note: note || '', pending: false
  }
}

export const seedExpenses = [
  makeExpense('expense-dinner', '晚餐 Yakitori Omino', 12400, 'JPY', 0.052, MEMBER_JASON, '餐飲', start.hour(19).minute(30).toISOString(), [MEMBER_AMY, MEMBER_JASON, MEMBER_KEN, MEMBER_TOM], ''),
  makeExpense('expense-hotel-deposit', 'Park Hyatt 訂金', 3000, 'HKD', 1, MEMBER_AMY, '住宿', start.subtract(9, 'day').toISOString(), [MEMBER_AMY, MEMBER_JASON, MEMBER_KEN, MEMBER_TOM], '訂房訂金'),
  makeExpense('expense-teamlab-ticket', 'teamLab 門票', 4200, 'JPY', 0.052, MEMBER_KEN, '門票', today.toISOString(), [MEMBER_AMY, MEMBER_JASON, MEMBER_KEN], 'Tom 這場不去'),
  makeExpense('expense-coffee', 'Glitch Coffee', 1600, 'JPY', 0.052, MEMBER_AMY, '餐飲', start.hour(8).minute(30).toISOString(), [MEMBER_AMY], '個人支出，不分帳')
]
seedExpenses[3].splitMode = 'none'
seedExpenses[3].visibility = 'private'

export const seedRepayments = [
  { id: 'repay-tom-jason', tripId: DEMO_TRIP_ID, fromId: MEMBER_TOM, toId: MEMBER_JASON, amountMinor: toMinor(161), expenseId: 'expense-dinner', status: 'confirmed', createdAt: start.hour(20).toISOString() }
]

export const seedMoments = [
  {
    id: 'moment-coffee', tripId: DEMO_TRIP_ID, creatorId: MEMBER_AMY, kind: 'normal',
    text: '酸度很高，適合早上提神。', media: [], mood: '😊', pointId: 'point-glitch-coffee',
    location: { lat: 35.6944, lng: 139.7580, label: 'Glitch Coffee' },
    capturedAt: start.hour(8).minute(21).toISOString(), timePrecision: 'exact',
    createdAt: start.hour(8).minute(25).toISOString(), visibility: 'trip', tags: ['#coffee']
  },
  {
    id: 'moment-discovery', tripId: DEMO_TRIP_ID, creatorId: MEMBER_AMY, kind: 'discovery',
    text: '本身完全沒有計畫，經過看到就進去了。', media: [], mood: '🤯', pointId: 'point-shimokitazawa',
    location: { lat: 35.6615, lng: 139.6682, label: '下北澤' },
    capturedAt: start.hour(14).minute(32).toISOString(), timePrecision: 'exact',
    createdAt: start.hour(14).minute(35).toISOString(), visibility: 'trip', tags: []
  },
  {
    id: 'moment-lunch', tripId: DEMO_TRIP_ID, creatorId: MEMBER_JASON, kind: 'normal',
    text: '午餐吃拉麵，人超多排了 40 分鐘。', media: [], mood: '😴', pointId: null,
    location: { lat: 35.6598, lng: 139.6994, label: '澀谷' },
    capturedAt: start.hour(13).minute(12).toISOString(), timePrecision: 'exact',
    createdAt: start.hour(13).minute(20).toISOString(), visibility: 'trip', tags: []
  },
  {
    id: 'moment-shibuya-sky', tripId: DEMO_TRIP_ID, creatorId: MEMBER_KEN, kind: 'normal',
    text: '整趟旅行最喜歡的地方！', media: [], mood: '❤️', pointId: 'point-shibuya-sky',
    location: { lat: 35.6585, lng: 139.7016, label: 'Shibuya Sky' },
    capturedAt: start.hour(18).minute(3).toISOString(), timePrecision: 'exact',
    createdAt: start.hour(18).minute(10).toISOString(), visibility: 'public', tags: ['#favourite']
  },
  {
    id: 'moment-private-note', tripId: DEMO_TRIP_ID, creatorId: MEMBER_AMY, kind: 'normal',
    text: '（只有我看得到）錢包快用完了，明天要換錢。', media: [], mood: null, pointId: null,
    location: null, capturedAt: start.hour(21).toISOString(), timePrecision: 'exact',
    createdAt: start.hour(21).toISOString(), visibility: 'private', tags: []
  },
  {
    id: 'moment-ticket', tripId: DEMO_TRIP_ID, creatorId: MEMBER_KEN, kind: 'physical',
    text: '差啲唔記得帶。', media: [], mood: null, pointId: 'point-teamlab',
    location: null, capturedAt: start.hour(19).toISOString(), timePrecision: 'day',
    createdAt: start.hour(19).toISOString(), visibility: 'trip', tags: [], physicalSubtype: '入場票'
  }
]

export function cloneSeed () {
  return JSON.parse(JSON.stringify({
    trips: seedTrips,
    members: seedMembers,
    points: seedPoints,
    decisions: seedDecisions,
    infoItems: seedInfoItems,
    todos: seedTodos,
    budgets: seedBudgets,
    exchangeRates: seedExchangeRates,
    expenses: seedExpenses,
    repayments: seedRepayments,
    moments: seedMoments
  }))
}
